import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormGroup,
    Validators,
    AbstractControl,
    ValidationErrors
} from '@angular/forms';
import {FarmService} from '@services/farm.service';
import {LoaderService} from '@services/loader.service';
import {SupplierService} from '@services/supplier.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-add-farm',
    templateUrl: './add-farm.component.html',
    styleUrl: './add-farm.component.scss'
})
export class AddFarmComponent implements OnInit {
    @Input() farmFormGroup: FormGroup;
    @Input() index: number;
    public farmhouseIndex = 0;
    openFarmIndex: number = 0;
    public birdTypes: any = [];
    // BREED - COMMENTED OUT
    // public breeds: any = [];
    @Output() removeFarmEvent = new EventEmitter<number>();

    private nameValidator(control: AbstractControl): ValidationErrors | null {
        if (!control.value) {
            return null;
        }
        const value = control.value.toString().trim();

        if (!/[a-zA-Z]/.test(value)) {
            return {invalidName: true};
        }
        return null;
    }

    private positiveNumberValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        if (!control.value && control.value !== 0) {
            return null;
        }
        const value = parseFloat(control.value);
        if (isNaN(value) || value <= 0) {
            return {invalidNumber: true};
        }
        return null;
    }

    constructor(
        private fb: FormBuilder,
        private supplierService: SupplierService
    ) {}

    ngOnInit(): void {
        this.getAllBirdType();
        // BREED - COMMENTED OUT
        // this.getAllBreed();
        this.setupFarmSizeCalculation();
        this.farmFormGroup.get('size')?.disable();
    }

    setupFarmSizeCalculation(): void {
        this.farmFormGroup.get('length')?.valueChanges.subscribe(() => {
            this.calculateFarmSize();
        });

        this.farmFormGroup.get('width')?.valueChanges.subscribe(() => {
            this.calculateFarmSize();
        });
    }

    calculateFarmSize(): void {
        const length = parseFloat(this.farmFormGroup.get('length')?.value) || 0;
        const width = parseFloat(this.farmFormGroup.get('width')?.value) || 0;

        if (length > 0 && width > 0) {
            const size = length * width;
            this.farmFormGroup.get('size')?.setValue(size, {emitEvent: false});
        } else {
            this.farmFormGroup.get('size')?.setValue(0, {emitEvent: false});
        }
    }

    get farmHouses(): FormArray {
        return this.farmFormGroup.get('farmHouses') as FormArray;
    }

    addFarmHouse(): void {
        const newFarmHouse = this.fb.group({
            id: [0],
            farmId: [this.index],
            name: ['', [Validators.required, this.nameValidator.bind(this)]],
            length: [
                0,
                [Validators.required, this.positiveNumberValidator.bind(this)]
            ],
            width: [
                0,
                [Validators.required, this.positiveNumberValidator.bind(this)]
            ],
            feedingSiloCapacity: [
                0,
                [Validators.required,this.positiveNumberValidator.bind(this)]
            ],            
            feedingSiloHeight: [
                0,
                [Validators.required,this.positiveNumberValidator.bind(this)]
            ],
            farmHousePartitions: this.fb.array([])
        });
        this.farmHouses.push(newFarmHouse);
    }

    removeFarm(): void {
        this.removeFarmEvent.emit(this.index);
    }

    getFarmHousePartitions(farmHouseIndex: number): FormArray {
        return this.farmHouses
            .at(farmHouseIndex)
            .get('farmHousePartitions') as FormArray;
    }

    addFarmHousePartition(farmHouseIndex: number): void {
        this.getFarmHousePartitions(farmHouseIndex).push(
            this.fb.group({
                id: [0],
                farmId: [this.index],
                farmHouseId: [farmHouseIndex],
                name: [
                    '',
                    [Validators.required, this.nameValidator.bind(this)]
                ],
                length: [
                    0,
                    [
                        Validators.required,
                        this.positiveNumberValidator.bind(this)
                    ]
                ],
                capacity: [
                    0,
                    [
                        Validators.required,
                        this.positiveNumberValidator.bind(this)
                    ]
                ],
                density: [0],
                sensors: [[]]
            })
        );
    }

    removeFarmHouse(farmHouseIndex: number): void {
        if (this.farmHouses.length > 2 && farmHouseIndex > 0) {
            this.farmHouses.removeAt(farmHouseIndex);
        }
    }

    removeFarmHousePartition(
        farmHouseIndex: number,
        partitionIndex: number
    ): void {
        if (this.getFarmHousePartitions(farmHouseIndex).length > 1) {
            this.getFarmHousePartitions(farmHouseIndex).removeAt(
                partitionIndex
            );
        }
    }
    setOpenFarm(index: number): void {
        this.farmhouseIndex = index;
        this.openFarmIndex = this.openFarmIndex === index ? null : index;
    }

    // BREED - COMMENTED OUT
    // getAllBreed() {
    //     this.supplierService.getBreedList().subscribe((result) => {
    //         this.breeds = result;
    //     });
    // }

    getAllBirdType() {
        this.supplierService.getBirdTypeList().subscribe((result) => {
            this.birdTypes = result;
        });
    }
    isControlInvalid(controlName: string): boolean {
        const control = this.farmFormGroup.get(controlName);
        return control?.invalid && (control.touched || control.dirty);
    }
}
